export const operators = [
    "==",
    "!=",
    "<",
    "<=",
    ">",
    ">=",
    "isEmpty",
];
